var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackdropVignette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 148,
    viewBox: "0 0 320 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H320V148H0V0Z",
    fill: "url(#paint0_linear_33_2180)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H320V148H0V0Z",
    fill: "url(#paint1_linear_33_2180)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H320V148H0V0Z",
    fill: "url(#paint2_linear_33_2180)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H320V148H0V0Z",
    fill: "url(#paint3_linear_33_2180)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33_2180",
    x1: 165.5,
    y1: 101.5,
    x2: 160,
    y2: 157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136433,
    stopOpacity: 0.106473
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.301585,
    stopOpacity: 0.235359
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569957,
    stopOpacity: 0.492821
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796055,
    stopOpacity: 0.740286
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_33_2180",
    x1: 160,
    y1: -4,
    x2: 160,
    y2: 34.9954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19231,
    stopOpacity: 0.689555
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385665,
    stopOpacity: 0.439033
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626007,
    stopOpacity: 0.20628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_33_2180",
    x1: 24.0443,
    y1: 62.8045,
    x2: 83.5,
    y2: 63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.098808,
    stopOpacity: 0.984059
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163071,
    stopOpacity: 0.967732
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227797,
    stopOpacity: 0.865569
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71833,
    stopOpacity: 0.230315
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_33_2180",
    x1: 292.776,
    y1: 76.5,
    x2: 239,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0835706,
    stopOpacity: 0.873268
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207018,
    stopOpacity: 0.720529
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507774,
    stopOpacity: 0.294577
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671586,
    stopOpacity: 0.159921
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackdropVignette);
export default __webpack_public_path__ + "static/media/backdrop-vignette.1174004df10cb645cdd9797e05571696.svg";
export { ForwardRef as ReactComponent };